import { combineReducers } from 'redux';
import LoginReducer from '../GlobalModules/Login/Reducers/LoginReducer';
import mainReducerData from './MainReducers';
export default combineReducers({
    LoginReducer,  //login reducer for login related data
    mainReducerData  //main reducer for application handlers
})